import type { Components, Theme } from '@mui/material';

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: () => ({
      fontSize: '1.4rem',
    }),
  },
};
